<template>
  <div class="historyComponent">
    <van-list
      v-model="loading"
      :offset="300"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="(item,index) in NewhistoryList" :key="index" class="content">
        <p class="monthHistory-title">{{ item.groupName }}</p>
        <div
          v-for="(historyItem,index) in item.data"
          :key="index"
          class="monthHistory-detail"
          @click="goHistoryDetail(historyItem.id)"
        >
          <div class="monthHistory-detail-left">
            <p>
              <span class="left-name hasMar">{{ historyItem.name }}</span>
              <span class="hasMar">{{ historyItem.YearMD }} {{ historyItem.HourMM }}</span>
            </p>
            <div style="font-size: 13px">
              {{ historyItem.companyOrReason }}
            </div>
          </div>
          <div class="monthHistory-detail-right">
            <span
              v-if="historyItem.beInvite === true && historyItem.status === 'WAITING_VERIFY'"
              class="right-icon"
              @click.stop="openInviteCode(historyItem.id,historyItem.askCode)"
            >
              <svg-icon icon-class="inviteCode" />
            </span>
            <span :class="historyItem.status">{{ historyItem.status | formatStatus }}</span>
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
// import QRCode from 'qrcodejs2'
// import { RefreshQrcode } from '@/api/user'
import {
  GetCheckRecordList,
  GetInviteReordList,
  GetAppointmentList,
  GetVisitorAppointList,
  GetCheckRecordHistoryList
} from '@/api/user';

export default {
  name: 'HistoryComponent',
  filters: {
    // 过滤访客状态
    formatStatus(val) {
      const statusMap = {
        CANCEL: '已取消',
        WAITING_AUDIT: '待审核',
        WAITING_VERIFY: '待验证',
        AUDIT_FAIL: '未过审',
        WAITING_VISIT: '待到访',
        VISITING: '访问中',
        FINISH: '已完成',
        UNVISIT: '过期未到访',
        OUTTIME_VISIT: '超时逗留',
        AUDIT_PASSED: '已通过',
        AUDIT_REFUSED: '已拒绝',
        OUTTIME_AUDIT: '超时未审核'

      };
      return statusMap[val];
    }
  },
  props: {
    size: {
      type: Number,
      default() {
        return 10;
      }
    },
    activeName: {
      type: String,
      default() {
        return '';
      }
    },
    visiDate: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      page: 1,
      total: null,
      loading: false,
      personalInfo: {},
      todayTime: '',
      historyList: [],
      NewhistoryList: [], // 处理统一字段后的historyList
      messageId: '' // 从消息模板进来打开二维码的id
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.size);
    },
    finished() {
      return this.page > this.maxPage;
    }
  },
  watch: {
    activeName: {
      handler(nv) {
        this.getList(nv);
      },
      immediate: true
    },
    historyList: {
      handler(nv) {
        var groupList = [];
        var list = nv.map(val => {
          const visitDate = val.visitDate || '';
          const groupName = `${visitDate.split(' ')[0].split('-')[0]}年${visitDate.split(' ')[0].split('-')[1]}月`;
          groupList.push(groupName);
          // const
          const lastStr = val.beVisitCompanyName || val.reason;
          const nameStr = val.name;
          let b;
          if (nameStr.length > 5) {
            b = nameStr.slice(0, 5) + '..';
          } else {
            b = nameStr;
          }
          return {
            id: val.id,
            name: b,
            companyOrReason: lastStr,
            // companyOrReason: val.beVisitCompanyName || val.reason,
            YearMD: visitDate ? visitDate.slice(5, -9) : '',
            HourMM: visitDate ? visitDate.slice(11, -3) : '',
            status: val.visitorStatus || val.auditStatus,
            qrCode: val.qrCode,
            beInvite: val.beInvite ? val.beInvite : '',
            askCode: val.askCode ? val.askCode : '',
            groupName
          };
        });
        groupList = [...new Set(groupList)].map(v => {
          var data = [];
          list.forEach(val => {
            if (v === val.groupName) {
              data.push(val);
            }
          });
          return {
            groupName: v,
            data
          };
        });
        this.NewhistoryList = groupList;
        this.loading = false;
      },
      // immediate: true
      deep: true
    }
  },
  activated() {
    if (this.page !== 1 || this.historyList.length) {
      this.page = 1;
      this.historyList = [];
      this.getList(this.activeName);
    }
  },
  created() {
    // 1205产品去掉二维码图标只在当天显示的需求
    // 1220自己加了来访日期之前二维码不可点
    // var today = new Date()
    // this.todayTime = this.FormatDate(today)
    // this.todayTime = Date.parse(this.todayTime)
    this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
  },
  methods: {
    // 员工历史记录列表
    getList(type) {
      console.log(type, 'type')
      const data = {
        page: this.page,
        size: this.size
      };
      switch (type) {
        case 'checkRecord':
          // 审核记录列表
          GetCheckRecordList(data).then(res => {
            this.historyList.push(...res.data.list);
            this.total = res.data.totals;
          });
          break;
        case 'inviteReord':
          // 邀约记录列表
          GetInviteReordList(data).then(res => {
            this.historyList.push(...res.data.list);
            this.total = res.data.totals;
          });
          break;
        case 'history':
          // 审核历史记录列表
          GetCheckRecordHistoryList(data).then(res => {
            this.historyList.push(...res.data.list);
            this.total = res.data.totals;
          });
          break;
        case 'appointment':
          // 预约记录列表
          GetAppointmentList(data).then(res => {
            res.data.list.forEach(item => {
              item.name = item.beVisitStaffName;
            });
            this.historyList.push(...res.data.list);
            this.total = res.data.totals;
          });
          break;
        default:
          // 访客预约列表
          GetVisitorAppointList(data).then(res => {
            res.data.list.forEach(item => {
              item.name = item.beVisitStaffName;
            });
            this.historyList.push(...res.data.list);
            this.total = res.data.totals;
          });
          break;
      }
    },

    onLoad() {
      if (this.page > this.maxPage) {
        return;
      } else {
        ++this.page;
      }
      this.getList(this.activeName);
    },
    // 到访当天点击展示二维码
    openQrcode(id, qrcode) {
      this.$emit('openQrcode', id, qrcode);
    },
    // 展示邀约码
    openInviteCode(id, askCode) {
      this.$emit('openInviteCode', id, askCode);
    },
    goHistoryDetail(id) {
      // 设置缓存
      this.$store.dispatch('setIncludeName');
      this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
      if (this.personalInfo.staff) {
        if (this.activeName === 'checkRecord' || this.activeName === 'inviteReord' || this.activeName === 'history') {
          this.$router.push({ name: 'staffHistoryDetail', query: { id: id, activeName: this.activeName }});
        } else {
          // 消息模板邀约码关闭后是没有activeName=》详情为空，不能用上面的switch
          this.$router.push({ name: 'historyDetail', query: { id: id, activeName: this.activeName }});
        }
      } else {
        this.$router.push({ name: 'historyDetail', query: { id: id, activeName: this.activeName }});
      }
    }
  }
};
</script>

<style lang="less" scoped>
.historyComponent {
  /deep/.van-cell {
    padding: 0rem !important;
  }
  .van-cell__value {
    width: 100%;
  }
  .content {
    //  padding: 0rem 0.15rem;
    .monthHistory-title {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
      //background: rgba(239, 239, 244, 1);
    }
    .monthHistory-detail {
      display: flex;
      justify-content: space-between;
      //align-items: center;
      font-size: 0.14rem;
      color: rgba(51, 51, 51, 0.7);
      //background: #fff;
      padding: 0.16rem 0.15rem;
      .monthHistory-detail-left {
        p {
          height: 0.24rem;
          line-height: 0.24rem;
          .left-name {
            font-size: 0.17rem;
            color: #001833;
          }
          .hasMar {
            margin-right: 0.16rem;
          }
        }
        p:first-child {
          margin-bottom: 0.02rem;
        }
      }
      .monthHistory-detail-right {
        display: flex;
        justify-content: flex-end;
        line-height: 100%;
        width: 35%;
        margin-top: 5px;
        .right-icon {
          margin-right: 0.18rem;
          .svg-icon {
            width: 0.28rem;
            height: 0.28rem;
          }
          > img {
            width: 0.28rem;
            height: 0.28rem;
          }
        }
        .CANCEL,
        .UNVISIT,
        .AUDIT_FAIL,
        .OUTTIME_AUDIT {
          color: rgba(51, 51, 51, 0.5);
        }
        .WAITING_AUDIT,
        .WAITING_VERIFY {
          color: #f2b230;
        }
        .OUTTIME_VISIT,
        .AUDIT_REFUSED {
          color: #f76260;
        }
        .VISITING,
        .WAITING_VISIT {
          color: #3b86ff;
        }
        .FINISH,
        .AUDIT_PASSED {
          color: #2dcc2c;
        }
      }
    }
    .monthHistory-detail:not(:last-child) {
      //border-bottom: 1px solid rgba(229, 229, 229, 1);
    }
  }
  /deep/ .van-tabs__wrap {
    height: 0.47rem;
    .van-tabs__nav--line {
      color: #856A25;
    }
    .van-tab {
      color: #333;
    }
    .van-tab--active {
      color: #856A25;
    }
    .van-tabs__line {
      background-color: #856A25;
    }
    .van-tab__text--ellipsis {
      overflow: unset;
    }
  }
}
</style>
